import { useState } from "react";
import { OffExpendInfo, OexpendOtherBody } from 'modules/objects';
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import CardOtherFormik from "./CardOther/CardOtherFormik";
import SpinnerBlock from "components/others/SpinnerBlock";
import vconst from "utils/helpers/structs/vconst";
import * as apiObject4Team from "api/apiObject4Team";
import { useToast } from "context/ToastContext";
import SolarIcon from 'components/icons/SolarIcon';

const ObjectCardOther = ({objectId, vobjectFull, setVobjectFull, fetchObject}) => {

    const { t } = useTranslation(['Objects']);
    const { showToast } = useToast();
    const [ showExpandInfo, setShowExpendInfo ] = useState(false);
    const [ showAddFormik, setShowAddFormik ] = useState(false);
    const [ isExpending, setIsExpending ] = useState(false);

    const handleAddExpend = async (expendData) => {
        setIsExpending(true);
        expendData = {
            ...expendData,
            amount : -expendData.amount,
            amountRate : -expendData.amountRate,
            expendTypeId : vconst.expendAddProductId,
            objectId : objectId
        }
        const resExpend = await apiObject4Team.addExpend(expendData);
        if (!resExpend) showToast(t('common:messError'), 'danger');
        await fetchObject() 
        setIsExpending(false);
    }

    return (<>
        <OffExpendInfo
            objectId={objectId}
            show={showExpandInfo}
            setShow={setShowExpendInfo}/> 

    
        {!showAddFormik
        ?(<div className="position-relative min-w-0">
                <SpinnerBlock show={isExpending}/>
                <div className="px-3">
                    <OexpendOtherBody 
                        onlyView={true}
                        expends={vobjectFull.expends} 
                        setShowExpendInfo={setShowExpendInfo} 
                        setShowSpinnerExpend={null}/>
                </div>

                <div className="text-center p-4">
                    <Button className="py-2"
                        onClick={()=>setShowAddFormik(true)}
                        size="sm"
                        variant="danger"><SolarIcon name="box-seam" className="me-2" />{t('addExpend.btnAddExpend')}</Button>
                </div>
            
            </div>)

        :(<CardOtherFormik
                handleAddExpend={handleAddExpend} 
                setShowAddFormik={setShowAddFormik}/>)}
    </>)
}

export default ObjectCardOther;